export const onDownloadCSVTemplate = (
	rows: Array<string>[],
	fileName: string,
) => {
	let csvContent = 'data:text/csv;charset=utf-8,';

	rows.forEach((row) => {
		csvContent += row.join(',') + '\r\n';
	});

	const encodedUri = encodeURI(csvContent);
	const link = document.createElement('a');
	link.setAttribute('href', encodedUri);
	link.setAttribute('download', `${fileName}.csv`);
	document.body.appendChild(link);
	link.click();
};
